import { WarehouseItemWorkRequestKind } from "@redotech/cockroachdb-codegen/tables/fulfillment/warehouse-item-work-request-kind";

/**
 * The kinds of work a merchant can ask its warehouse to do to a unit.
 *
 * The kind is `WarehouseItemWorkRequestKind` — the DB enum the repo, the search,
 * the filters, the RPC schemas and the handlers already speak. Nothing declares
 * a parallel list; anywhere a request is offered, parsed, or labelled reads
 * these.
 *
 * This lives in the warehouse domain rather than beside any one surface,
 * because requests are made from more than one: a processing flow step today,
 * and ad hoc from the merchant's requests page.
 */
export const WORK_REQUEST_KINDS = Object.values(WarehouseItemWorkRequestKind);
